// ANETT HORVATH — Restore Access Page
// Cross-device session recovery via email + member code.

import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useStore } from '../../store/database';
import LanguageSwitcher from '../../components/LanguageSwitcher';

export default function RestoreAccessPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const store = useStore();
  const [email, setEmail] = useState('');
  const [memberCode, setMemberCode] = useState('');
  const [error, setError] = useState('');

  const handleRestore = (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    if (!email || !memberCode) { setError(t('auth.fieldRequired')); return; }

    // Find user by email
    const user = store.users.find(u => u.email === email && !u.deleted_at);
    if (!user) { setError(t('common.notFound')); return; }

    // Find member by user_id and member_code
    const member = store.members.find(m => m.user_id === user.id && m.member_code === memberCode.toUpperCase() && !m.deleted_at);
    if (!member) { setError(t('common.notFound')); return; }

    // Restore session
    const session = { user_id: user.id, role: user.role, member_id: member.id };
    localStorage.setItem('ah_auth_session', JSON.stringify(session));
    useStore.setState({ session });

    store._log(member.id, 'session_restored', { method: 'member_code' });
    store._sysEvent('session_restored', { member_id: member.id });
    store._persist();

    navigate('/gateway');
  };

  const inp = 'w-full border-b border-charcoal/15 py-2.5 text-sm font-sans bg-transparent focus:border-charcoal/40 transition-colors placeholder:text-charcoal/25';

  return (
    <div className="min-h-dvh bg-ivory flex flex-col items-center justify-center px-6">
      <div className="w-full max-w-sm space-y-8">
        <div className="text-center space-y-2">
          <h1 className="font-serif text-3xl tracking-widest-xl">AH</h1>
          <p className="text-[11px] tracking-widest-2xl uppercase text-charcoal/40 font-sans">{t('auth.restoreAccess')}</p>
        </div>

        <form onSubmit={handleRestore} className="space-y-4">
          <input type="email" value={email} onChange={e => setEmail(e.target.value)}
            placeholder={t('auth.email')} className={inp} />
          <input type="text" value={memberCode} onChange={e => setMemberCode(e.target.value)}
            placeholder={t('auth.memberCode')} className={inp} />
          {error && <p className="text-xs text-burgundy font-sans">{error}</p>}
          <button type="submit" className="w-full py-3 bg-charcoal text-ivory text-[11px] tracking-widest-xl uppercase font-sans hover:bg-charcoal/90 transition-colors">
            {t('auth.restore')}
          </button>
        </form>

        <div className="text-center space-y-2">
          <Link to="/login" className="text-[11px] tracking-widest uppercase font-sans text-charcoal/40 hover:text-charcoal transition-colors block">
            ← {t('auth.enterHouse')}
          </Link>
        </div>
        <div className="flex justify-center pt-4"><LanguageSwitcher /></div>
      </div>
    </div>
  );
}
